// Banner Slider
$(document).ready(function () {
    $('.main-banner').slick({
        dots: true,
        infinite: true,
        speed: 800,
        fade: true,
        cssEase: 'linear',
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: false,
        // responsive: [
        //     {
        //         breakpoint: 992,
        //         settings: {
        //             arrows: false,
        //         }
        //     }
        // ]
    });


    // Recruiter Ticker Slider
    $('.recruiter-ticker').slick({
        slidesToShow: 8,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 5000,
        cssEase: 'linear',
        infinite: true,
        arrows: false,
        dots: false,
        variableWidth: true,
        pauseOnHover: false,
        pauseOnFocus: false,
        responsive: [
            {
                breakpoint: 992,
                settings: { slidesToShow: 3 }
            },
            {
                breakpoint: 576,
                settings: { slidesToShow: 2 }
            }
        ]
    });
    $('.about-slider').slick({
        dots: true,
        infinite: true,
        speed: 200,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        arrows: false,
        variableWidth: true,
    });
    $('.slick-img-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.slick-content-slider',
        autoplay: false /* Set to true if you want auto play */
    });

    // Initialize Right Content Slider
    $('.slick-content-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        asNavFor: '.slick-img-slider',
        dots: false,
        arrows: true,
        prevArrow: $('#cclms-slick-prev'),
        nextArrow: $('#cclms-slick-next'),
        fade: true,
        focusOnSelect: false
    });
    $('.product-img-slider').not('.slick-initialized').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        autoplay: false,
        speed: 400
    });
    $('.product-card').hover(

        function () {
            var slider = $(this).find('.product-img-slider');

            slider.slick('slickGoTo', 1);
            slider.slick('slickSetOption', 'autoplay', true, true);
        },

        function () {
            var slider = $(this).find('.product-img-slider');

            slider.slick('slickSetOption', 'autoplay', false, true);
            slider.slick('slickGoTo', 0);
        }

    );

    // Fix for Bootstrap Tabs
    $('button[data-bs-toggle="pill"]').on('shown.bs.tab', function () {
        $('.product-img-slider').slick('setPosition');
    });

    // Fix for Bootstrap Accordion
    $('.accordion-collapse').on('shown.bs.collapse', function () {
        $('.product-img-slider').slick('setPosition');
    });

    $('.testimonial-slider').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        autoplay: false,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });
});



$('.banner_slider .banner_list').slick({
    dots: false,
    infinite: true,
    arrows: true,
    speed: 300,
    slidesToShow: 1,
    adaptiveHeight: true
});

$('.tab_collection_sliders .tab_slider_main').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
                infinite: true,
                dots: false
            }
        },
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: true,
                dots: false
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        },
        {
            breakpoint: 481,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
});

$('.product-image-slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  dots: false,
  infinite: true
});

$(document).on('click', '.slick-arrow', function(e){
  e.preventDefault();
  e.stopPropagation();
});
$('.product-card-slider').hover(
  function(){
    $(this).find('.product-image-slider').slick('slickGoTo', 1);
  },
  function(){
    $(this).find('.product-image-slider').slick('slickGoTo', 0);
  }
);
$('.thumbnails-wrapper .product_list').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: true,
                dots: false
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 400,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        }
    ]
});

// pdp page quantity

$(document).on("click", ".qtybox .btnqty", function () {
    var qty = parseInt($(this).parent('.qtybox').find('.quantity-input').val());
    if ($(this).hasClass('qtyplus')) {
        qty++;
    } else {
        if (qty > 1) {
            qty--;
        }
    }
    qty = (isNaN(qty)) ? 1 : qty;
    $(this).parent('.qtybox').find('.quantity-input').val(qty);
});

// tabbed content
// http://www.entheosweb.com/tutorials/css/tabs.asp
$(".tab-container .tab_content").hide();
// $(".tab-container .tab_content:first").show();
$('.tab-container').each(function (k, v) {
    $(v).find('.tab_content:first').show();
});

/ if in tab mode /
$("ul.tabs li").click(function () {
    var parent = $(this).parents('.tab-container');

    $(parent).find(".tab_content").hide();
    var activeTab = $(this).attr("rel");
    $(parent).find("#" + activeTab).fadeIn();

    $(parent).find("ul.tabs li").removeClass("active");
    $(this).addClass("active");

    $(parent).find(".tab_drawer_heading").removeClass("d_active");
    $(parent).find(".tab_drawer_heading[rel^='" + activeTab + "']").addClass("d_active");

    $('.tab_slider_main').slick('refresh');

});
/ if in drawer mode /
$(".tab_drawer_heading").click(function () {
    var parent = $(this).parents('.tab-container');

    $(parent).find(".tab_content").hide();
    var d_activeTab = $(this).attr("rel");
    $(parent).find("#" + d_activeTab).fadeIn();

    $(parent).find(".tab_drawer_heading").removeClass("d_active");
    $(this).addClass("d_active");

    $(parent).find("ul.tabs li").removeClass("active");
    $(parent).find("ul.tabs li[rel^='" + d_activeTab + "']").addClass("active");

    $('.tab_slider_main').slick('refresh');
});

// window.addEventListener("scroll", function () {
//     let header = document.querySelector(".site-header");

//     if (window.scrollY > 100) {
//         header.classList.add("sticky");
//     } else {
//         header.classList.remove("sticky");
//     }
// });


const header = document.querySelector(".site-header");

window.addEventListener("scroll", function () {

    if (window.scrollY > 100) {

        if (!header.classList.contains("sticky")) {

            // Step 1: add pre-state
            header.classList.add("pre-sticky");

            // Step 2: wait a tiny bit so browser registers it
            setTimeout(() => {
                header.classList.add("sticky");
                header.classList.remove("pre-sticky");
            }, 300); // 🔥 important delay
        }

    } else {
        header.classList.remove("sticky");
        header.classList.remove("pre-sticky");
    }

});

const backToTopBtn = document.getElementById('backToTopBtn');
        window.addEventListener('scroll', () => {
            if (window.scrollY > 300) {
                backToTopBtn.classList.add('show');
            } else {
                backToTopBtn.classList.remove('show');
            }
        });

        backToTopBtn.addEventListener('click', () => {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });



document.addEventListener("DOMContentLoaded", function () {
  const forms = document.querySelectorAll(".ajax-cart-form");

  forms.forEach(form => {
    form.addEventListener("submit", function (e) {
      e.preventDefault();

      const button = form.querySelector(".add-cart-btn");
      const originalText = button.textContent;

      const formData = new FormData(form);

      // ⚡ VERY SHORT loading (optional)
      button.textContent = "Adding...";
      button.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      })
      .then(res => res.json())
      .then(data => {

        // ✅ SHOW SUCCESS IMMEDIATELY (no waiting)
        button.textContent = "Added to Cart ✓";

        setTimeout(() => {
          button.textContent = originalText;
          button.disabled = false;
        }, 1200);

        // ⚡ Update cart in background (no UI delay)
        updateCartCount();

      })
      .catch(err => {
        console.error(err);
        button.textContent = "Error!";
        button.disabled = false;

        setTimeout(() => {
          button.textContent = originalText;
        }, 1500);
      });
    });
  });
});

function updateCartCount() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const count = cart.item_count;

      const countWrapper = document.getElementById("CartCount");
      const countElement = document.querySelector("[data-cart-count]");

      if (countElement) {
        countElement.textContent = count;
      }

      // show/hide bubble
      if (count > 0) {
        countWrapper.classList.remove("critical-hidden");
      } else {
        countWrapper.classList.add("critical-hidden");
      }
    });
}
document.addEventListener("DOMContentLoaded", function () {
  updateCartCount();
});
